import { render, staticRenderFns } from "./PreviewAndProduce.vue?vue&type=template&id=6f72bbf2&scoped=true&"
import script from "./PreviewAndProduce.vue?vue&type=script&lang=js&"
export * from "./PreviewAndProduce.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAndProduce.vue?vue&type=style&index=0&id=6f72bbf2&scoped=true&lang=scss&"
import style1 from "./PreviewAndProduce.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72bbf2",
  null
  
)

export default component.exports